import { render, staticRenderFns } from "./Index-reports.vue?vue&type=template&id=428aa5cd"
import script from "./Index-reports.vue?vue&type=script&lang=js"
export * from "./Index-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports